// Authenticated /dashboard/help page — same content, dashboard context.
import Navigation from "../components/Navigation";
import KnowledgeBaseShell from "../components/KnowledgeBaseShell";

export default function DashboardHelp() {
  return (
    <div data-testid="dashboard-help-page">
      <Navigation />
      <KnowledgeBaseShell mode="dashboard" />
    </div>
  );
}
